import { switchColors } from './consts'

const baseStyle = {
  button: {
    thumb: {
      bg: 'white',
    },
    track: {
      ring: 3,
    },
  },
}

function sizeXl() {
  const button = {
    fontSize: 'lg',
    minW: 58,
    thumb: {
      h: 28,
      w: 28,
    },
    track: {
      h: 32,
    },
  }

  const label = {
    size: 'xl',
  }

  return { button, label }
}

function sizeLg() {
  const button = {
    fontSize: 'md',
    minW: 50,
    thumb: {
      h: 24,
      w: 24,
    },
    track: {
      h: 28,
    },
  }

  const label = {
    size: 'lg',
  }

  return { button, label }
}

function sizeMd() {
  const button = {
    fontSize: 'sm',
    minW: 42,
    thumb: {
      h: 20,
      w: 20,
    },
    track: {
      h: 24,
    },
  }

  const label = {
    size: 'md',
  }

  return { button, label }
}

function sizeSm() {
  const button = {
    fontSize: 'xs',
    minW: 34,
    thumb: {
      h: 16,
      w: 16,
    },
    track: {
      h: 20,
    },
  }

  const label = {
    size: 'sm',
  }

  return { button, label }
}

const defaultProps = {
  size: 'md',
  variant: 'primary',
}

const parts = ['container', 'button', 'label']

const sizes = {
  sm: sizeSm,
  md: sizeMd,
  lg: sizeLg,
  xl: sizeXl,
}

const variants = {
  primary: {
    button: {
      track: {
        bg: switchColors.main,
      },
    },
  },
  green: {
    button: {
      track: {
        bg: switchColors.green,
      },
    },
  },
  red: {
    button: {
      track: {
        bg: switchColors.red,
      },
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
